import Vue from 'vue'
import Vuex from 'vuex'

// modules
import auth from './modules/auth';
import chat from './modules/chat';
import settings from './modules/settings';
import ecommerce from './modules/ecommerce';
import mail from './modules/mail';
import storeModule from './modules/storeModule';
import sidebar from './modules/sidebar';
import users from './modules/users'
import catalogues from './modules/catalogues'
import products from './modules/products'
import extras from './modules/extras'
import telegramBot from './modules/telegramBot'
import shopping from './modules/shoppings'
import banks from './modules/banks'
import cashiers from './modules/cashiers'
import deliveryStore from './modules/delivery/store'
import deliveryCompany from './modules/delivery/company'
import storeCategories from './modules/storeCategories'
import dashboard from './modules/dashboards'
import events from "./modules/Events"
import accounts from "./modules/accounts"
import sales from "./modules/sales"
import ticketUsers from "./modules/ticket-users";
import plans from './modules/plans';
import licenseSales from './modules/licenseSales';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        auth,
        // chat,
        settings,
        // ecommerce,
        // mail,
        sidebar,
        users,
        storeModule,
        catalogues,
        products,
        extras,
        telegramBot,
        shopping,
        deliveryStore,
        deliveryCompany,
        banks,
        cashiers,
        storeCategories,
        dashboard,
        events,
        accounts,
        sales,
        ticketUsers,
        plans,
        licenseSales
    }
})
